import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../../../../components/Loading/Loading";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import localeText from "../../../../locale";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import { CartItem } from "./CartItem";
import useShopSections from "../../../Shop/hooks/useShopSections";
import { useHistory } from "react-router-dom";
import IntegrationService from "../../../../service/IntegrationService";
import checkmark from "../../../../pages/images/checkmark.svg";
import { useLocation } from "react-router-dom";
import UnifiedOrderSummary from "../UnifiedOrderSummary/UnifiedOrderSummary";
import { usePayment } from "../Checkout/context/PaymentContext";


const CartItems = ({
  walletBalance,
  order,
  setOrder,
  isLoadingOrder,
  currencyProduct,
  currencyCodeUser,
  currencyUser,
  setCashback,
  setPrice,
  orderItems,
  setOrderItems,
  walletExtracoinBalance,
  userPercentExtracoin,
  walletExtracoinBalanceForex,
  setOrderIsEmpty,
  orderIsEmpty,
  cashback,
  isLoadingWalletExtracoinBalanceForex,
  userInfo,
}) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderCurrency = isFringeBenefitsPage
    ? order?.fringeBenefit?.currency
    : order?.itens?.[0]?.product?.currency;

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const urlToCheckCatalog = isFringeBenefitsPage
    ? "/fringe-benefits?search=ALL&currency=ALL&area=ALL"
    : "/shop";

  const { showErrorToast } = useToastContext();
  const [loading, setLoading] = useState(false);
  const [isLoadingToContinue, setIsLoadingToContinue] = useState(false);
  const [itemRemoved, setItemRemoved] = useState(false);
const getUserInfoService = new GetUserInfoService();
const integrationService = new IntegrationService();
const { page, setPage } = usePayment();

const currencyFormat = {
  USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  };

  const toast = useRef(null);

  useShopSections({
    onError: (code) => showErrorToast(code, toast?.current),
  });

  const history = useHistory();

  async function sendInitiateCheckout() {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "InitiateCheckout",
    });
    const user = await getUserInfoService.getUserInfo(
      localStorage.getItem("__extraconomy_token"),
      localStorage.getItem("__extraconomy_username")
    );
    let ip = await integrationService.getUserIp();
    let date = new Date();
    let payload = {
      eventData: {
        currency: "",
        value: 0,
      },
      eventName: "InitiateCheckout",
      eventTime: Math.floor(date.getTime() / 1000),
      userData: {
        email: user.result.user?.email ? user.result.user.email : "",
        ipAddress: ip.data.ip,
        phone: user.result.user?.phoneNumber ? user.result.user.phoneNumber : "",
        userAgent: window.navigator.userAgent,
      },
    };
    let res = await integrationService.sendEvent(payload);
    return res;
  }

  useEffect(() => {
    if (orderItems) {
      setLoading(true);
      let cashbackValue = 0;

      orderItems.forEach((item) => {
        let price;

        if (order?.isGuestCart) {
          price = item?.priceUnitary || 0;
        } else if (item?.product.promotionalPriceUnique && !item?.product.productVariation) {
          price = item?.product.promotionalPriceUnique;
        } else {
          price = item?.priceUnitary;
        }

        const cashbackPercent = item?.product?.percentExtraCoin / 100 || 0;
        cashbackValue = cashbackValue + price * cashbackPercent * item.quantity;
      });

      setCashback(cashbackValue);
      setLoading(false);
    }
  }, [orderItems, order, setCashback, setLoading]);

  const isGuestCart = order?.isGuestCart;
  const isLoadingAll = isGuestCart
    ? !isLoadingWalletExtracoinBalanceForex
    : !isLoadingWalletExtracoinBalanceForex && userPercentExtracoin !== null && userPercentExtracoin !== undefined;

  return (
    <div className="pt-4 pb-0 md:pb-8" style={{ minHeight: "70vh" }}>
      {!isLoadingAll && !orderIsEmpty ? (
        <div>
          <hr />
          <Loading classNameIcon={"text-4xl"} />
        </div>
      ) : (
        <>
          {order && !orderIsEmpty && (
            <div
              className="font-bold text-xl my-3 flex gap-2 align-items-center justify-content-between"
              style={{ color: "#344563" }}
            >
              {localeText("confirmation")}{" "}
              <Button
                link
                className="p-no-outline flex gap-2 align-items-center"
                style={{ color: "#245AE5" }}
                onClick={() => {
                  history.push("/shop");
                }}
              >
                <i className="pi pi-arrow-left text-xs"></i>{" "}
                <span className="underline">{localeText("backAction")}</span>
              </Button>
            </div>
          )}
          {order && !orderIsEmpty && (
            <div className="grid grid-nogutter gap-4">
              <div
                className="col-12 md:col-8 card h-full p-4 border-round-lg border-none flex flex-column gap-3"
                style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
              >
                <div className="uppercase border font-bold" style={{ color: "#344563" }}>
                  {localeText("productServices")}
                </div>
                <hr className="mt-0 mb-2"></hr>
                {isFringeBenefitsPage ? (
                  <>
                    <CartItem
                      product={order.fringeBenefit}
                      setLoading={setLoading}
                      setOrder={setOrder}
                      setOrderItems={setOrderItems}
                      setOrderIsEmpty={setOrderIsEmpty}
                      order={order}
                    />
                  </>
                ) : (
                  <>
                    {orderItems?.map((product, idx) => (
                      <CartItem
                        product={product}
                        setLoading={setLoading}
                        setOrder={setOrder}
                        setOrderItems={setOrderItems}
                        setOrderIsEmpty={setOrderIsEmpty}
                        order={order}
                        key={idx}
                        setItemRemoved={setItemRemoved}
                        currencyFormat={currencyFormat}
                      />
                    ))}
                  </>
                )}

                {itemRemoved && (
                  <div
                    className="col-12 p-3 flex align-items-center gap-3 font-medium mt-3"
                    style={{
                      border: "1px solid #08D48B14",
                      borderRadius: "8px",
                      backgroundColor: "#E6FBF3",
                      color: "#0D0D0E",
                    }}
                  >
                    <img src={checkmark} alt="checkmark" />{" "}
                    <span className="flex-1">{localeText("itemsRemoved")}</span>{" "}
                    <Button
                      icon="pi pi-times"
                      link
                      className="p-button-sm border-round p-no-outline"
                      style={{ width: "16px", height: "16px", color: "#19191C" }}
                      onClick={() => {
                        setItemRemoved(false);
                      }}
                    />
                  </div>
                )}
              </div>

              {order && (
                <UnifiedOrderSummary
                  context="cart"
                  orderItems={orderItems}
                  order={order}
                  cashback={cashback}
                  isFringeBenefitsPage={isFringeBenefitsPage}
                  currencyProduct={currencyProduct}
                  currencyCodeUser={currencyCodeUser}
                  currencyFormat={currencyFormat}
                  walletExtracoinBalance={walletExtracoinBalance || 0}
                  walletExtracoinBalanceForex={walletExtracoinBalanceForex || 0}
                  userPercentExtracoin={userPercentExtracoin || 0}
                  walletBalance={walletBalance || 0}
                  orderCurrency={orderCurrency}
                  loading={loading}
                  setLoading={setLoading}
                  isLoadingToContinue={isLoadingToContinue}
                  setIsLoadingToContinue={setIsLoadingToContinue}
                  showErrorToast={showErrorToast}
                  sendInitiateCheckout={sendInitiateCheckout}
                  setPage={setPage}
                  page={page}
                  setPrice={setPrice}
                  orderKey={orderKey}
                  urlToCheckCatalog={urlToCheckCatalog}
                  userInfo={userInfo}
                />
              )}
            </div>
          )}

          {(!order || orderIsEmpty) && (
            <div
              className="flex flex-column card p-5 border-none border-round-lg mt-7 mx-auto text-center"
              style={{ boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)", maxWidth: "792px" }}
            >
              <div className="font-bold" style={{ color: "#344563" }}>
                {localeText("emptyCartText")}
              </div>
              <hr className="my-4"></hr>
              <div
                className="mb-6 mt-3 flex mx-auto text-sm"
                style={{ color: "#505F79", maxWidth: "375px" }}
              >
                {localeText("emptyCartSuggestion")}
              </div>
              <Link to={urlToCheckCatalog}>
                <button
                  className="cursor-pointer py-3 px-4 border-none border-round-lg font-medium"
                  style={{ backgroundColor: "#28AB69", color: "#FAFBFC" }}
                >
                  {localeText("checkCatalog")}
                </button>
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CartItems;
